<div class="modal-header">
    <div class="modal-title">Income Statement</div>
    <button id="low-value-notice-close" type="button" class="close" aria-label="Close" (click)="onClose()">
        <span aria-hidden="true"></span>
    </button>
</div>

<div class="modal-body">
    <p class="text-center">
        There is an error initializing Income Statements, please click “Reload” to reload page. If issue persists, please contact <a href="mailto:support@valzy.com">support&#64;valzy.com</a>.
    </p>
</div>

<div class="modal-footer">
    <button id="add-interim-popup-cancel" type="button" class="button secondary__button large__button position-static"
        (click)="onClose()">Cancel</button>
    <button id="add-interim-popup-add" type="button" class="button primary__button large__button position-static"
           (click)="reload()">Reload</button>
</div>